<template>
    <div class="appointment-attachment-upload">
        <div class="contentBox-img" >
            <div class="attachmentLeft" v-show="imgArr.length">
                <div style="height: 180px" >
                    <ul id="viewers" style="display: none">
                        <li v-for="(item, index) in imgArr" :key="index">
                            <img :src="item.propertiesValue" />
                        </li>
                    </ul>
                </div>
                <div class="currentImgIndex">{{ carouselIndex + 1 + ' / ' + imgArr.length }}</div>
            </div>
            <div class="uploader" v-if="imgArr.length">
                <upload-new-btn
                    ref="uploadButton"
                    type="btn"
                    multiple
                    businessKey="default"
                    bucket="c-tms"
                    contentType="application/octet-stream"
                    :needBtn="false"
                    :publicRead="1"
                    :compressImage="true"
                    :compressQuality="0.5"
                    @callback="uploadResponse"
                >
                    <i class="el-icon-plus pictures"></i>
                </upload-new-btn>
                <i class="el-icon-delete" @click="deleteBtn"></i>
            </div>
            <upload-new-btn
                class="upload"
                v-else
                ref="uploadButton"
                type="btn"
                multiple
                businessKey="default"
                bucket="c-tms"
                contentType="application/octet-stream"
                :needBtn="false"
                :publicRead="1"
                :compressImage="true"
                :compressQuality="0.5"
                @callback="uploadResponse"
            >
                <i class="el-icon-plus notImg"></i>
            </upload-new-btn>
        </div>
    </div>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import UploadNewBtn from '@/components/lots/OSS/UploadNewBtn';

export default {
    components: {
        UploadNewBtn
    },
    props: {
        propertiesList: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            viewer: null,
            carouselIndex: 0, // 轮播图当前的索引
            imgArr: []
        };
    },

    methods: {
        uploadResponse (response) {
            if (this.propertiesList.length + response.length > 6) {
                this.$message.warning('最多只能上传6个附件,请重新上传！');
                return false;
            }
            response.forEach(item => {
                this.propertiesList.push({
                    propertiesValue: item.data.downUrl,
                    propertiesName: item.data.name,
                    propertiesType: this.getFileType(item.data.name)
                });
            });
            this.carouselIndex = 0;
            this.viewer.destroy();
            this.getImgList();
        },
        updateViewer () {
            this.carouselIndex = 0;
            this.viewer.destroy();
            setTimeout(() => {
                this.initViewer();
            });
        },
        // 获取文件类型
        getFileType (name) {
            const type = name.split('.')[1];
            return type.toUpperCase();
        },
        // 删除图片
        deleteBtn () {
            this.propertiesList.splice(this.carouselIndex, 1);
            this.updateViewer();
        },
        initViewer () {
            const barOptions = { show: true, size: 'small' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: false,
                button: true,
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    prev: {
                        show: true,
                        size: 'small',
                        click: () => {
                            if (this.carouselIndex === 0) {
                                this.carouselIndex = this.imgArr.length - 1;
                            } else {
                                this.carouselIndex -= 1;
                            }
                            this.viewer.prev(true);
                        }
                    },
                    reset: barOptions,
                    next: {
                        show: true,
                        size: 'small',
                        click: () => {
                            if (this.carouselIndex === this.imgArr.length - 1) {
                                this.carouselIndex = 0;
                            } else {
                                this.carouselIndex += 1;
                            }
                            this.viewer.next(true);
                        }
                    },
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
        },
        getImgList () {
            this.imgArr = [];
            this.imgArr = this.propertiesList;
            this.$nextTick(() => {
                this.initViewer();
            });
        }
    },
    mounted () {
        this.getImgList();
    },
    beforeDestroy () {
        this.viewer.destroy();
    }
};
</script>

<style lang="less">
.appointment-attachment-upload {
    .currentImgIndex{
        text-align: center;
    }
    .notImg {
        border-radius: 4px;
        border: 2px dashed #00bcbf;
        color: #00bcbf;
        font-size: 40px;
        width: 130px;
        line-height: 130px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -65px;
        margin-top: -65px;
    }
    .upload {
        position: relative;
        height: 130px;
    }
    .el-upload {
        text-align: center;
    }
    .contentBox-img {
        width: 100%;
    }
    .uploader {
        padding-top: 6px;
        text-align: center;

        > div {
            display: inline-block;
        }
        .pictures {
            border-radius: 4px;
            border: 1px dashed #00bcbf;
            color: #00bcbf;
            width: 20px;
            line-height: 20px;
        }
        > i {
            cursor: pointer;
            color: #00bcbf;
            font-size: 22px;
            vertical-align: middle;
            margin-left: 30px;
        }
    }
}
</style>
